import get from 'lodash/get';
import { NOW_PLAYING_GUIDE_ID } from '../constants/dialogs/nowPlaying';

const NAMESPACE = 'dialog';

export const selectIsNowPlayingDialogOpen = (state) =>
  get(state, [NAMESPACE, 'isNowPlayingDialogOpen'], false);
export const selectNowPlayingGuideItem = (state) =>
  get(state, [NAMESPACE, NOW_PLAYING_GUIDE_ID], {});
export const selectIsDownloadAppDialogOpen = (state) =>
  get(state, [NAMESPACE, 'isDownloadAppDialogOpen'], false);
export const selectDidShowDownloadAppDialog = (state) =>
  get(state, [NAMESPACE, 'didShowDownloadAppDialog'], false);
export const selectIsTextMeTheAppDialogOpen = (state) =>
  get(state, [NAMESPACE, 'isTextMeTheAppDialogOpen'], false);
